import React, { Fragment } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Form } from 'react-bootstrap';

import Helmet from 'react-helmet';
import MainLP from '../../components/Layout/Main/Main';
// scss
import './Courses.scss';
function Courses() {
  const [regionSelect, setRegionSelect] = useState('');
  const [userData, setUserData] = useState([]);
  const dummy_data = [
    {
      id: 'RegionI',
      img: './PSOCC.jpg',
      title: 'Public Safety Officers Candidate Course (PSOCC)',
      class1: '500',
      class2: '500',
      total_participants: '300',
      course_objective:
        'This course is designed substantially to equip the senior non-commissioned officers (SPO4) of the PNP with the most intricate cognitive knowledge, skills, and proper attitudes required in performing the duties and responsibilities of a member of the organization with an officer rank.\n\n\nSpecifically, the program is a four and one-half (4 ½) months course intended to improve the cognitive knowledge, aptitude and affective faculties of the potential officers to prepare them to assume an officer rank and its corresponding duties and responsibilities',
    },
    {
      id: 'RegionII',
      img: './PSSLC.jpg',
      title: 'Public Safety Senior Leadership Course (PSSLC)',
      class1: '50',
      class2: '50',
      total_participants: '50',
      course_objective:
        'The course is designed to equip the senior non-commissioned officers (SPO1-SPO3) of the PNP with the knowledge, attitudes, skills, habits and values needed for an effective management and responsible leadership in their respective units. \n\n After the completion of a three and one-half (3 ½) months course, the students and trainees shall be able to: \n 1) Demonstrate productive and responsive supervisory and leadership qualities and skills. \n 2) Assume greater responsibility for mid-level position. \n 3) Perform with competence the responsibilities required of his/her respective position and assignment.',
    },
    {
      id: 'RegionIII',
      img: './PSJLC.jpg',
      title: 'Public Safety Junior Leadership Course (PSJLC)',
      class1: '50',
      class2: '50',
      total_participants: '50',
      course_objective:
        'The course is essentially designed to equip the junior non-commissioned officers with the rank of PO3 of the PNP with fundamental knowledge, skills and proper attitude required for team-leading assignments. Specifically, the program is a four and one-half (4 ½) months course intended to develop the leadership potentials of the police participants to prepare them assume higher responsibilities within the organization.',
    },
    {
      id: 'RegionIV',
      img: './PSBRC.jpg',
      title: 'Public Safety Officers Candidate Course (PSOCC)',
      class1: '50',
      class2: '50',
      total_participants: '50',
      course_objective:
        'This is a six (6) months course designed to equip and develop the PNP recruits with the knowledge, attitudes, skills, habits and values required for a law enforcement officer. This is a transformation from a civilian to a regimented life in preparation for their actual duties and responsibilities.',
    },
  ];

  useEffect(() => {
    setUserData({
      id: 'RegionI',
      img: './PSOCC.jpg',
      title: 'Public Safety Officers Candidate Course (PSOCC)',
      participants: '300',
    });
    setRegionSelect('RegionI');
    console.log('s');
  }, []);
  useEffect(() => {
    const regiongather = dummy_data.filter((region) => region.id === regionSelect);
    setUserData(regiongather);
  }, [regionSelect]);
  useEffect(() => {
    console.log(userData);
  }, [userData]);
  return (
    <Fragment>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <MainLP>
        <section className='coursesweb'>
          <img
            className='img-fluid w-100'
            src={userData[0]?.img}
            alt='img'
          />
          <div className='courses-info'>
            <div className='container'>
              <p className='h5'>{userData[0]?.title}</p>
              <p className='h6 mb-4'>Number of Participants: {userData[0]?.total_participants}</p>
              <div className='participants-info shadow-lg '>
                <div className='container'>
                  <div className='row'>
                    <div className='col'>
                      <div className='d-flex justify-content-center region-select '>
                        <div
                          className='d-flex mb-1'
                          style={{ alignItems: 'center' }}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='76.29'
                            height='58.336'
                            viewBox='0 0 76.29 58.336'
                            className='container'
                          >
                            <path
                              id='map'
                              d='M50.86,94.11,25.43,86.839V35.811l25.43,7.266ZM55.1,42.756l16.834-6.734a3.177,3.177,0,0,1,4.358,2.952V83.316a3.2,3.2,0,0,1-2,2.954L55.1,93.938Zm-53.1.9,19.193-7.677V87.157L4.359,93.9A3.179,3.179,0,0,1,0,90.945V46.6a3.179,3.179,0,0,1,2-2.95Z'
                              transform='translate(0 -35.792)'
                              fill='#33469a'
                            />
                          </svg>
                          <p className='nopadding h4 mx-3'>Region:</p>
                        </div>
                        <Form.Group className='region-dropdown'>
                          <Form.Select
                            value={regionSelect}
                            defaultValue='RegionI'
                            onChange={(e) => setRegionSelect(e.target.value)}
                          >
                            <option value='RegionI'>Region I</option>
                            <option value='RegionII'>Region II</option>
                            <option value='RegionIII'>Region III</option>
                            <option value='RegionIV'>Region IV</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </div>

                    <div className='col'>
                      <div className='d-flex justify-content-center'>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='65.5'
                          height='52.4'
                          viewBox='0 0 65.5 52.4'
                          className='img-fluid'
                        >
                          <path
                            id='users'
                            d='M32.74,32.75A10.644,10.644,0,1,0,22.188,22.106,10.567,10.567,0,0,0,32.74,32.75Zm5.117,3.275H27.643c-8.034,0-14.543,6.11-14.543,13.642A2.819,2.819,0,0,0,16.007,52.4H49.493A2.819,2.819,0,0,0,52.4,49.667C52.4,42.135,45.891,36.025,37.857,36.025ZM52.4,16.375a8.188,8.188,0,1,0-8.187-8.187A8.188,8.188,0,0,0,52.4,16.375ZM18.821,22.106a13.634,13.634,0,0,1,.165-1.628,7.412,7.412,0,0,0-3.644-.828H9.014A9.3,9.3,0,0,0,0,29.2a1.863,1.863,0,0,0,1.8,1.914H22.221A13.785,13.785,0,0,1,18.821,22.106ZM13.1,16.375A8.188,8.188,0,1,0,4.912,8.188,8.188,8.188,0,0,0,13.1,16.375ZM56.484,19.65H50.155a8.534,8.534,0,0,0-3.67.843,14.022,14.022,0,0,1,.164,1.613,13.8,13.8,0,0,1-3.394,9.006H63.693A1.864,1.864,0,0,0,65.5,29.2,9.293,9.293,0,0,0,56.484,19.65Z'
                            fill='#33469a'
                          />
                        </svg>
                        <div className='participants ms-3'>
                          <p className='nopadding '>Class 1: {userData[0]?.class1} Participants</p>
                          <p className='nopadding '>Class 2: {userData[0]?.class2} Participants</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='course-objective'>
          <div className='container'>
            <h5 className='my-5 fw-bold'>COURSE OBJECTIVE</h5>

            {userData[0]?.course_objective.split('\n').map((str) => (
              <>
                <br />
                <p className='nopadding'>{str}</p>
              </>
            ))}
          </div>
        </section>
      </MainLP>
    </Fragment>
  );
}

export default Courses;
